export enum CertificateSize {
	A3 = 'A3',
	A4 = 'A4',
	A5 = 'A5',
	Legal = 'Legal',
	Letter = 'Letter',
}